module.exports = __webpack_public_path__ + "img/service-251.1c56d681.png";